import $ from 'jquery';
const selector = '.js-focus-outside';

export default function focusOutside() {
    $(document).on('touchstart', (evt) => {
        if (!$(evt.target).closest(selector).length) {
            const $target = $(selector);

            if ($target.is(':visible')) {
                $target.blur();
            }
        }
    });
}
